import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import ShowUIPropPreviewBody from "./ShowUIPropPreviewBody";

export default function ShowUIPropPreview() {
  return (
    <PiPopupWindowPreview
      size="medium"
      body={<ShowUIPropPreviewBody />}
      header={<PiPopupHeaderBar interactionType={InteractionType.ShowUIProp} title="Show UI Prop" />}
    />
  );
}
